import { useAppSelector } from "~/app/store";

import useFlag from "~/config/flags";

import ManageFlaggedInventoryButton from "./ManageFlaggedInventoryButton";

interface TopActionButtonsProps {
  isAdjustingBins: boolean;
}

export const TopActionButtons: React.FC<TopActionButtonsProps> = ({
  isAdjustingBins
}) => {
  const binFlaggingEnabled = useAppSelector(
    (state) => state.store.usersFulfillmentCenter?.binFlaggingEnabled
  );
  const showWorkstationBinMaintenance =
    useFlag().enableWorkstationBinMaintenance;

  return (
    <>
      {binFlaggingEnabled &&
        !showWorkstationBinMaintenance &&
        !isAdjustingBins && <ManageFlaggedInventoryButton />}
    </>
  );
};
